// This represents the flag value for the env variables for controlling MSW.
export const ENABLED = 'enabled';
